import styled from 'styled-components'

export const StyledContainer = styled.div``

export const StyledGridContainer = styled.div`
  margin-top: 24px;
`

export const StyledPaginationContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 24px;
`

export const ButtonsContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

// Used in useReportingPage
export const StyledDiv = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const StyledIRESSVerificationStatus = styled.div<{ verified: boolean }>`
  height: 30px;
  width: 120px;

  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 10px;
  border-radius: 4px;
  background-color: ${({ verified }) => (verified ? '#e8f5e9' : '#ffebee')};
  color: ${({ verified }) => (verified ? '#2e7d32' : '#c62828')};
  font-weight: 600;
  font-size: 14px;
`

export const StyledIRESSVerificationStatusIcon = styled.div`
  margin-right: 6px;
  display: flex;
  align-items: center;
`

export const StyledLogo = styled.img`
  padding: 24px 0 8px 0;
  cursor: pointer;
`
// ^ Used in useReportingPage
